// extracted by mini-css-extract-plugin
module.exports = {"vGray1":"#83929c","field":"FieldCommunity_field__2KMfw","field_disabled":"FieldCommunity_field_disabled__2lhLt"};